<template>
  <div v-if="showItem" class="t-notice">
    <div class="t-notice__header">
      <span>{{ data.date }}</span>
      <span>{{ data.time }}</span>
    </div>
    <div class="t-notice__title">{{ data.title }}</div>
    <div class="t-notice__text" v-html="data.text"></div>
    <button class="t-notice__delete" @click.prevent="Delete()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L13 13M13 1L1 13" stroke="#52A8F2" stroke-width="2"/>
      </svg>
    </button>
  </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        props: ['data', 'showItem'],
        methods: {
            ...mapActions('notice',['LoadNotice']),
            Delete(){
                this.$http.delete('notice/' + this.data.id)
                    .then(response => response.json())
                    .then(data => {
                        if(data.success)
                            this.LoadNotice(this.$route.query);
                    })
            }
        }
    }
</script>

<style lang="sass">
.t-notice
  width: 100%
  position: relative
  padding: 24px 0 16px
  //margin: 0 24px 24px 0
  line-height: 1.4
  display: flex
  align-items: flex-start
  &:not(:last-child)
    border-bottom: 1px solid $border
  //&._new
    border: 10px solid $promo
    padding: 14px
    .t-notice__delete
      top: 14px
      right: 14px
  &__delete
    //position: absolute
    //top: 38px
    //right: 24px
    margin-left: auto
    padding: 14px
    background: transparent
    border: none
    outline: none
    cursor: pointer
  &__header
    width: 140px
    min-width: 140px
    margin-right: 30px
    font-size: 16px
    //margin-bottom: 18px
  &__title
    color: $blue
    font-size: 16px
    font-weight: 600
    //line-height: 1
    width: 200px
    min-width: 200px
    margin-right: 24px
    //margin-bottom: 18px
  &__text
    margin-right: 24px
    //max-width: 460px
    a
      color: $blue

@media(max-width: 920px)
  .t-notice
    padding: 16px
    margin-bottom: 10px
    flex-direction: column
    background: #ffffff
    box-shadow: 0 12px 16px rgba(0, 108, 202, 0.1)
    border-radius: 16px
    position: relative
    &:not(:last-child)
      border-bottom: none
    &__title
      padding-bottom: 16px
      margin: 24px 0 16px
      width: 100%
      border-bottom: 1px solid $border
    &__text
      margin-right: 0
    &__delete
      position: absolute
      top: 4px
      right: 16px

</style>



// WEBPACK FOOTER //
// src/vue_components/Notice.vue